import { Stack } from "@mui/material";

import { Slider } from "../Slider";
import { Text } from "../Text";
import { aggregateBreakdowns } from "./aggregateBreakdowns";
import { type NumberBreakdown } from "./types";

interface RatingsBreakdownProps {
  numberBreakdowns: NumberBreakdown[];
  // Optional array of default values to display in the breakdown
  // When provided, these values will always be shown in the breakdown
  // even if they have no corresponding data in numberBreakdowns
  // Example: [1, 2, 3, 4, 5] will show all rating levels regardless of data
  defaultValues?: number[];
}

export function NumbersBreakdown(props: RatingsBreakdownProps) {
  const { numberBreakdowns, defaultValues } = props;

  const aggregatedBreakdowns = aggregateBreakdowns(numberBreakdowns, defaultValues);

  return (
    <Stack spacing={1}>
      {aggregatedBreakdowns.map(({ value, percentage }) => (
        <Stack key={value} direction="row" spacing={3} alignItems="center">
          <Text semibold variant="caption">
            {value}
          </Text>

          <Slider
            disabled
            value={percentage}
            max={100}
            thumb={false}
            size="small"
            sx={{ "&.Mui-disabled": { color: "unset" } }}
          />
        </Stack>
      ))}
    </Stack>
  );
}
